import types from '../constants/types'
import config from '@/config'
// import cookies from 'js-cookie'
import { toQueryString } from '@/utils'
import axios from '@/http'

export const authorityAction = {
  login({ commit, state }, param, apiParam = config.apiParam) {
    commit(types.LOGIN_REQUEST)
    axios({
      method: 'post',
      url: '/' + param.path,
      transformRequest: [function (data, headers) {
        return toQueryString(data)
      }],
      data: Object.assign({
        'token': param.token
      },
      param.data,
      apiParam)
    })
    .then((res) => {
     
      if (res && res.status === 200) {
        if (res.data.code !== '000000') {
          commit(types.LOGIN_FAILURE, {
            data: res.data
          })
          if (typeof param.onFail === 'function') {
            param.onFail(res.data)
          }
        } else {
          commit(types.LOGIN_SUCCESS, {
            data: res.data
          })
          window.localStorage.setItem('token',param.token)
         
          if (typeof param.onSuccess === 'function') {
            param.onSuccess(res.data)
          }
        }
      }
    })
    .catch((error) => {
      commit(types.LOGIN_FAILURE, {
        data: error
      })
      if (typeof param.onFail === 'function') {
        param.onFail(error)
      }
    })
  },
  wxAccess({ commit, state }, param, apiParam = config.apiParam) {
    commit(types.LOGIN_REQUEST)
    axios({
      method: 'post',
      baseURL: config.serviceHost,
      url: '/wx/get-channel_lable',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      transformRequest: [function (data, headers) {
        return toQueryString(data)
      }],
      data: Object.assign(param.data, apiParam)
    })
    .then((res) => {
     
      if (res && res.status === 200) {
        if (res.data.code !== '000000') {
          commit(types.LOGIN_FAILURE, {
            data: res.data
          })
          if (typeof param.onFail === 'function') {
            param.onFail(res.data)
          }
        } else {
          commit(types.LOGIN_SUCCESS, {
            data: res.data
          })
          window.localStorage.setItem('open_id',res.data.info.channel_lable)
          if (typeof param.onSuccess === 'function') {
            param.onSuccess(res.data)
          }
        }
      }
    })
    .catch((error) => {
      commit(types.LOGIN_FAILURE, {
        data: error
      })
      if (typeof param.onFail === 'function') {
        param.onFail(error)
      }
    })
  },
  mobileAccess({ commit, state }, param, apiParam = config.apiParam) {
    commit(types.LOGIN_REQUEST)
    axios({
      method: 'post',
      baseURL: config.serviceHost,
      url: '/' + param.path,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      transformRequest: [function (data, headers) {
        return toQueryString(data)
      }],
      data: Object.assign({
        'token': param.token
      },
      param.data,
      apiParam)
    })
    .then((res) => {
     
      if (res && res.status === 200) {
        if (res.data.code !== '000000') {
          commit(types.LOGIN_FAILURE, {
            data: res.data
          })
          if (typeof param.onFail === 'function') {
            param.onFail(res.data)
          }
        } else {
          commit(types.LOGIN_SUCCESS, {
            data: res.data
          })
          window.localStorage.setItem('token',param.token)
          if (typeof param.onSuccess === 'function') {
            param.onSuccess(res.data)
          }
        }
      }
    })
    .catch((error) => {
      commit(types.LOGIN_FAILURE, {
        data: error
      })
      if (typeof param.onFail === 'function') {
        param.onFail(error)
      }
    })
  },
  reLogin({ commit, state }, param, apiParam = config.apiParam) {
    const channel_lable = window.localStorage.getItem('open_id')
    axios({
      method: 'post',
      baseURL: config.serviceHost,
      url: '/wx/config',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      transformRequest: [function (data, headers) {
        return toQueryString(data)
      }],
      timeout: 60000,
      data: Object.assign({
        open_id: channel_lable,
        user_id: '162',
      },
      param.data,
      apiParam)
    })
      .then((res) => {
        if (res && res.status === 200) {
          if (res.data.code !== '000000') {
            commit(types.LOGIN_FAILURE, {
              data: {
                info: {
                  open_id: channel_lable
                },
                msg: '登录无效'
              }
            })
            if (typeof param.onFail === 'function') {
              param.onFail(res.data)
            }
          } else {
            commit(types.LOGIN_SUCCESS, {
              data: {
                info: {
                  open_id: channel_lable
                },
                msg: '登录成功'
              }
            })
            if (typeof param.onSuccess === 'function') {
              param.onSuccess(res.data)
            }
          }
        }
      })
      .catch((error) => {
        commit(types.LOGIN_FAILURE, {
          data: {
            info: {
              open_id: channel_lable
            },
            msg: '登录无效'
          }
        })
        if (typeof param.onFail === 'function') {
          if (config.debug) {
            param.onFail({ msg: JSON.stringify(error) })
          } else {
            param.onFail({ msg: '服务器无响应' })
          }
        }
      })
  },
}
